<div id="pergunta-condominio">
  <div class="container-data">
    <div class="row">
      <div class="col-12">
        <card>
          <mat-stepper linear #stepper>
            <mat-step [stepControl]="formPerfilInicial" #stepperPerfilInicial>
              <form [formGroup]="formPerfilInicial">
                <ng-template matStepLabel>PERFIL INICIAL</ng-template>
                <div class="row">
                  <div class="row d-flex align-items-end">
                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                      <label class="form-label">RAZÃO SOCIAL DO GERADOR</label>
                      <input type="text" class="form-control" formControlName="razaoSocial">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                      <label class="form-label">NOME DO RESPONSÁVEL POR EXECUTAR O
                        PAGAMENTO</label>
                      <input type="text" class="form-control" formControlName="nomeResponsavel">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                      <label class="form-label">E-MAIL DO RESPONSÁVEL POR EXECUTAR O
                        PAGAMENTO</label>
                      <input type="text" class="form-control" formControlName="emailResponsavel">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                      <label class="form-label">DATA LIMITE PARA EMISSÃO DE NOTA
                        FISCAL</label>
                      <select name="dataLimite" id="dataLimite" class="form-select"
                              formControlName="dataLimite">
                        <option value="" selected disabled>Selecione</option>
                        <option *ngFor="let data of listDias; let i = index" value="{{data}}">
                          {{data}}</option>
                      </select>
                    </div>
                  </div>

                </div>
                <div class="pt-3 d-flex justify-content-end container">
                  <button class="btn btn-secondary" style="margin-right: 1em"
                          matStepperPrevious>Anterior
                  </button>
                  <button class="btn btn-primary " matStepperNext
                          (click)="proximoStepper(stepperPerfilInicial)">Próximo
                  </button>
                </div>
              </form>
            </mat-step>

            <mat-step [stepControl]="formEstruturaCondominio" #stepperEstruturaCondominio>
              <form [formGroup]="formEstruturaCondominio">
                <ng-template matStepLabel>ESTRUTURA DO GERADOR</ng-template>


                <div>
                  <h4 class="card-title">Lixeira Central</h4>
                  <hr/>
                </div>

                <div class="row d-flex align-items-end">
                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                    <label class="form-label" for="local">EXISTE UM LOCAL FECHADO (QUARTO)
                      ONDE OS
                      RESÍDUOS FICAM ARMAZENADOS</label>
                    <select name="local" id="local" class="form-select"
                            formControlName="localArmazenamento">
                      <option value="" disabled>Selecione</option>
                      <option [value]="true">Sim</option>
                      <option [value]="false">Não</option>
                    </select>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12"
                       *ngIf="!checkBoolean(formEstruturaCondominio.value.localArmazenamento)">
                    <label class="form-label">ONDE SERÁ CRIADA A LIXEIRA CENTRAL?</label>
                    <input type="text" class="form-control" formControlName="lixeiraCentral">
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                    <label class="form-label">É UMA ÁREA DE VISIBILIDADE DO USUÁRIO?</label>
                    <select name="areaVisivel" id="areaVisivel" class="form-select"
                            formControlName="areaVisivel">
                      <option value="" disabled>Selecione</option>
                      <option [value]="true">Sim</option>
                      <option [value]="false">Não</option>
                    </select>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                    <label class="form-label">É UMA ÁREA COBERTA?</label>
                    <select name="areaCoberta" id="areaCoberta" class="form-select"
                            formControlName="areaCoberta">
                      <option value="" disabled>Selecione</option>
                      <option [value]="true">Sim</option>
                      <option [value]="false">Não</option>
                    </select>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                    <label class="form-label">QUAL A LARGURA DA PORTA DA
                      LIXEIRA:</label>
                    <input type="number" min="0" class="form-control"
                           formControlName="larguraPorta">
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 pt-4">
                    <label class="form-label">QUAL A METRAGEM QUADRADA DA
                      LIXEIRA:</label>
                    <input type="number" min="0" class="form-control"
                           formControlName="metragemLixeira">
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                    <label class="form-label">QUANTOS PASSOS DA LIXEIRA CENTRAL ATÉ O
                      PONTO DE
                      PARADA DO CAMINHÃO:</label>
                    <select class="form-select" name="passosLixeira" id="passosLixeira"
                            formControlName="passosLixeira">
                      <option value="" disabled>Selecione</option>
                      <option value="ATE_DEZ">até 10 passos</option>
                      <option value="ONZE_VINTE">entre 11 e 20 passos</option>
                      <option value="VINTE_UM_TRINTA">entre 21 e 30 passos</option>
                      <option value="TRINTA_UM_QUARENTA">entre 31 e 40 passos</option>
                      <option value="QUARENTA_UM_CINQUENTA">entre 41 e 50</option>
                      <option value="CINQUENTA_UM_SESSENTA">entre 51 e 60</option>
                      <option value="MAIS_SESSENTA">mais de 60</option>
                    </select>
                  </div>
                  <div
                    *ngIf="formEstruturaCondominio.value.passosLixeira === 'MAIS_SESSENTA'"
                    class="col-xl-3 col-lg-3 col-md-12 col-sm-12"
                  >
                    <label class="form-label">
                      QUANTOS PASSOS ATÉ A LIXEIRA:
                    </label>
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      formControlName="qtdPassos"
                    >
                  </div>
                  <div *ngIf="formEstruturaCondominio.value.passosLixeira === 'MAIS_SESSENTA'" class="col-xl-6 col-lg-6 col-md-12 col-sm-12"
                       style="padding-top: 1.1em">
                    <label class="form-label">ALGUM FUNCIONÁRIO SEU PODE
                      REGISTRAR O VOLUME DE RESÍDUO EXISTENTE NO CONTAINER NA PLATAFORMA DA
                      ECOPLAT E LEVAR O RESÍDUO ATÉ UMA DISTÂNCIA DE 15 PASSOS DO PONTO
                      DE PARADA DO CAMINHÃO:
                    </label>
                    <select formControlName="funcionarioPodeLevarLixo"
                            class="form-select" id="funcionarioPodeLevarLixo"
                            name="funcionarioPodeLevarLixo">
                      <option value="" selected disabled>Selecione
                      </option>
                      <option [value]="true">Sim</option>
                      <option [value]="false">Não</option>
                    </select>
                  </div>
                  <div *ngIf="formEstruturaCondominio.value.passosLixeira === 'MAIS_SESSENTA'" class="col-xl-6 col-lg-6 col-md-12 col-sm-12"
                       style="padding-top: 1em">
                    <label class="form-label">
                      DESCREVA COMO ISSO PODE SER FEITO:
                    </label>
                    <textarea
                      type="text"
                      class="form-control"
                      id="descricao" formControlName="descricao" rows="5"
                      cols="5"
                    ></textarea>
                    <span class="fs-10 text-muted">
                      Caso não tenha as condições ideais de distância os
                      coletadores poderão perder o interesse pela sua coleta.</span>
                  </div>

                </div>

                <div class="pt-3">
                  <h4 class="card-title">Lixeira do andar/setor</h4>
                  <hr/>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pt-3">
                    <div class="row">
                      <div>
                        <label class="form-label">SEU GERADOR TEM QUARTO DE LIXEIRA NOS ANDARES OU SETORES:</label>
                        <select name="lixeiraAndar" id="lixeiraAndar" class="form-select"
                                formControlName="lixeiraAndar">
                          <option value="" disabled>Selecione</option>
                          <option [value]="true">Sim</option>
                          <option [value]="false">Não</option>
                        </select>
                      </div>
                      <div class="pt-3"
                           *ngIf="checkBoolean(formEstruturaCondominio.value.lixeiraAndar)">
                        <label class="form-label">QUAL O COMPRIMENTO E A LARGURA DA LIXEIRA
                          DO ANDAR:</label>
                        <input type="text" class="form-control"
                               formControlName="comprimentoLixeiraAndar">
                      </div>
                      <div class="pt-3"
                           *ngIf="!checkBoolean(formEstruturaCondominio.value.lixeiraAndar)">
                        <label class="form-label">ESCREVA COMO OS USUÁRIOS DESCARTAM OS
                          RESÍDUOS
                          DENTRO
                          DA SEU GERADOR:</label>
                        <input type="text" class="form-control"
                               formControlName="descarteResiduo">
                      </div>
                    </div>
                  </div>

                  <div *ngIf="checkBoolean(formEstruturaCondominio.value.lixeiraAndar)"
                       class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div class="row">

                      <h5 class="d-flex justify-content-center">ANEXE UMA FOTO DA LIXEIRA DO
                        ANDAR:
                      </h5>
                      <div class="div-image-containers d-flex justify-content-center">
                        <input #fileUploadLixeiraAndar type="file"
                               (change)="uploadImg($event, entityId, 'fotoLixeiraAndar')"
                               style="display: none" accept="image/png, image/jpeg, image/jpg">
                        <img class="image-container" src="{{getImg('fotoLixeiraAndar')}}" alt="Foto da Lixeira do
                                                    Andar">

                      </div>
                      <div class="div-button-image-container  justify-content-end ">
                        <button (click)="fileUploadLixeiraAndar.click()"
                                class="btn btn-success m-1">
                          Escolher
                        </button>
                        <button [disabled]="!entity?.fotoLixeiraAndar?.id"
                                (click)="removerImagem(entity?.fotoLixeiraAndar, 'fotoLixeiraAndar')"
                                class="btn btn-danger m-1">
                          Excluir
                        </button>
                      </div>

                    </div>

                  </div>
                  <div *ngIf="!checkBoolean(formEstruturaCondominio.value.lixeiraAndar)"
                       class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div class="row d-flex justify-content-center">

                      <h5 class="d-flex justify-content-center">ANEXE UMA FOTO DO LOCAL ONDE
                        OS USUÁRIOS DESCARTAM OS RESÍDUOS:
                      </h5>
                      <div class="div-image-containers d-flex justify-content-center">
                        <input #fileUploadFotoResiduo type="file"
                               (change)="uploadImg($event, entityId, 'fotoDescarteResiduo')"
                               style="display: none" accept="image/png, image/jpeg, image/jpg">
                        <img class="image-container" src="{{getImg('fotoDescarteResiduo')}}"
                             alt="Imagem do container">

                      </div>
                      <div class="div-button-image-container d-flex justify-content-center">
                        <button (click)="fileUploadFotoResiduo.click()"
                                class="btn btn-success m-1">
                          Escolher
                        </button>
                        <button [disabled]="!entity?.fotoDescarteResiduo?.id"
                                (click)="removerImagem(entity?.fotoDescarteResiduo, 'fotoDescarteResiduo')"
                                class="btn btn-danger m-1">
                          Excluir
                        </button>
                      </div>

                    </div>
                  </div>
                </div>

                <hr class="mt-2 mb-2">

                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <h5>ANEXE UMA FOTO DA LIXEIRA CENTRAL:</h5>
                    <div class="div-image-containers">
                      <input #fileUploadfotoLixeiraCentral type="file"
                             (change)="uploadImg($event,entityId, 'fotoLixeiraCentral')"
                             style="display: none" accept="image/png, image/jpeg, image/jpg">
                      <img class="image-container"
                           src="{{getImg('fotoLixeiraCentral')}}"
                           alt="Imagem do container">

                    </div>
                    <div
                      class="div-button-image-container justify-content-center">
                      <button (click)="fileUploadfotoLixeiraCentral.click()"
                              class="btn btn-success m-1">
                        Escolher
                      </button>
                      <button [disabled]="!entity?.fotoLixeiraCentral?.id"
                              (click)="removerImagem(entity?.fotoLixeiraCentral, 'fotoLixeiraCentral')"
                              class="btn btn-danger m-1">
                        Excluir
                      </button>
                    </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <h5>ANEXE UMA FOTO DA PORTA DA LIXEIRA CENTRAL:</h5>
                    <div class="div-image-containers">

                      <input
                        #fileUploadfotoPortaCentral
                        type="file"
                        (change)="uploadImg($event, entityId, 'fotoPortaCentral')"
                        style="display: none"
                        accept="image/png, image/jpeg, image/jpg"
                      >
                      <img class="image-container w-100"
                           src="{{getImg('fotoPortaCentral')}}"
                           alt="Imagem do container">
                    </div>
                    <div
                      class="div-button-image-container justify-content-center">
                      <button (click)="fileUploadfotoPortaCentral.click()"
                              class="btn btn-success m-1">
                        Escolher
                      </button>
                      <button [disabled]="!entity?.fotoPortaCentral?.id"
                              (click)="removerImagem(entity?.fotoPortaCentral, 'fotoPortaCentral')"
                              class="btn btn-danger m-1">
                        Excluir
                      </button>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="pt-3 d-flex justify-content-end container">
                    <button class="btn btn-secondary" style="margin-right: 1em"
                            matStepperPrevious>Anterior
                    </button>
                    <button class="btn btn-primary " matStepperNext
                            (click)="proximoStepper(stepperEstruturaCondominio)">Próximo
                    </button>
                  </div>
                </div>
              </form>


            </mat-step>

            <mat-step [stepControl]="formFuncionalidades" #stepperFuncionalidades>
              <form [formGroup]="formFuncionalidades">
                <ng-template matStepLabel>FUNCIONALIDADES DO GERADOR</ng-template>

                <div>
                  <h4 class="card-title">FUNCIONÁRIOS</h4>
                  <hr/>
                </div>

                <div class="row d-flex align-items-end">
                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                    <label class="form-label">QUAL HORÁRIO DE FUNCIONAMENTO DA PORTARIA:</label>
                    <input type="text" class="form-control"
                           formControlName="horarioFuncionamentoPortaria">
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                    <label class="form-label">QUANTOS FUNCIONÁRIOS SÃO DA EQUIPE DE LIMPEZA:</label>
                    <input type="number" min="0" class="form-control"
                           formControlName="funcionariosLimpeza">
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                    <label class="form-label">QUAL O HORÁRIO DE TRABALHO FUNCIONÁRIOS DA
                      LIMPEZA:</label>
                    <input type="text" min="0" class="form-control"
                           formControlName="horarioFuncionarioLimpeza">
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                    <label class="form-label">SEMPRE TEM ALGUÉM PARA ACOMPANHAR A COLETA COBRINDO
                      HORÁRIOS DE ALMOÇO:</label>
                    <select class="form-select" formControlName="horarioAlmoco">
                      <option value="" disabled>Selecione</option>
                      <option [value]="true">Sim</option>
                      <option [value]="false">Não</option>
                    </select>
                  </div>
                </div>

                <div class="pt-3">
                  <h4 class="card-title">USUÁRIOS</h4>
                  <hr/>
                </div>

                <div class="row d-flex align-items-end">
                  <div>
                    <label class="form-label">QUAIS SÃO OS CANAIS DE COMUNICAÇÃO QUE O GESTOR E A
                      ADMINISTRAÇÃO SE COMUNICAM COM OS USUÁRIOS:</label>
                    <input type="text" class="form-control" formControlName="canaisComunicacao">
                  </div>
                </div>

                <div>
                  <h4 class="card-title">COLETA</h4>
                  <hr/>
                </div>

                <div class="row d-flex align-items-end">
                  <div>
                    <label class="form-label">QUAL SEU TIPO DE COLETA:</label>
                    <select class="form-select" formControlName="tipoColeta">
                      <option value="" disabled>Selecione</option>
                      <option value="COLETA_FREQUENTE">preciso de uma coleta frequente por ter
                        pouco
                        espaço de
                        armazenagem
                      </option>
                      <option value="COLETA_MES">Posso aguardar um mês ou mais para tentar volume
                        de
                        venda
                      </option>
                    </select>
                  </div>
                </div>

                <div class="pt-3 d-flex justify-content-end container">
                  <button class="btn btn-secondary" style="margin-right: 1em"
                          matStepperPrevious>Anterior
                  </button>
                  <button class="btn btn-primary " matStepperNext
                          (click)="proximoStepper(stepperFuncionalidades)">Próximo
                  </button>
                </div>
              </form>

            </mat-step>
            <mat-step [stepControl]="formAssinatura">
              <form [formGroup]="formAssinatura">
                <ng-template matStepLabel>ASSINATURA</ng-template>
                <div class="row">
                  <label class="form-label">ESCOLHA SUA ASSINATURA:</label>
                  <mat-select class="form-select" formControlName="assinatura" multiple required>
                    <mat-option *ngFor="let topping of optAssinaturas"
                                [value]="topping.key">{{topping.value}}</mat-option>
                  </mat-select>
                </div>
              </form>
              <div class="pt-3 d-flex justify-content-end container">
                <button class="btn btn-success" (click)="salvarPerguntas()">Salvar</button>
              </div>
            </mat-step>
          </mat-stepper>
        </card>
      </div>
    </div>
  </div>

</div>
